import React from 'react'
import PropTypes from 'prop-types'
import { injectIntl } from 'react-intl'
import { Controller } from 'react-hook-form'

import AntDropdown from 'components/AntDropdown'
import FormItem from 'components/Form/Item'

const LAST_EVENT_BUDGET_TRANSLATION_INDEX = 10

const EventBudget = (props) => {
  const {
    intl,
  } = props

  const budgetLocalization = intl.formatMessage({ id: 'contactRequestForm.budget' })

  const eventBudgetOptions = []

  for (let index = 0; index <= LAST_EVENT_BUDGET_TRANSLATION_INDEX; index++) {
    eventBudgetOptions.push({
      id: intl.formatMessage({ id: `contactRequestForm.event_budget_ranges.${index}` }),
      text: intl.formatMessage({ id: `contactRequestForm.event_budget_ranges.${index}` }),
    })
  }

  return (
    <FormItem label={budgetLocalization}>
      <Controller
        name="eventBudget"
        defaultValue={eventBudgetOptions[0].id}
        render={({
          field: { onChange, onBlur, value, name, ref },
        }) => (
          <AntDropdown
            ref={ref}
            segments={[
              {
                name: 'eventBudget',
                options: eventBudgetOptions,
                currentValue: value,
              },
            ]}
            useNativeSelectOnMobile={true}
            onChange={(values) => onChange(values.eventBudget)}
            onBlur={onBlur}
          />
        )}
      />
    </FormItem>
  )
}

EventBudget.propTypes = {
  intl: PropTypes.object.isRequired,
}

export default injectIntl(EventBudget)
